export enum ProgressState {
    Ready = 'ready',
    Error = 'error',
    Waiting = 'waiting',
    Loading = 'loading',
    Finalizing = 'finalizing',
    Done = 'done',
}
